// extracted by mini-css-extract-plugin
export default {"description":"qL0UJ","links":"mpNQH","links__section":"c16gl","app-link":"bl95U"};